<template>
  <section class="pb-12">
    <BlFlexContainerMv justify-content="space-between">
      <div>
        <BlCapsuleAv v-if="courseType" class="course__type ml-12 mt-12" variation="informational" size="large">{{
          courseTypeWording
        }}</BlCapsuleAv>
      </div>
      <div v-if="course.rating && isReviewExists" href="#" @click.prevent="showReviewSheet">
        <BlCapsuleAv class="review mr-12 mt-12" variation="informational" size="large">
          <BlFlexContainerMv>
            <IcoStarMinor class="rating__star" color="#FFA726" />
            <BlTextAv variation="body-16" weight="medium" class="rating__value">
              {{ course.rating.value }}
            </BlTextAv>
          </BlFlexContainerMv>
        </BlCapsuleAv>
      </div>
    </BlFlexContainerMv>
    <BlFlexContainerMv direction="column" justify-content="space-between" padding="16px 16px">
      <BlTextAv class="course__name" variation="subheading-18" tag="h1" weight="medium">{{ course.name }}</BlTextAv>
    </BlFlexContainerMv>

    <div class="mh-16">
      <BlFlexContainerMv
        padding="12px 16px"
        :class="getPrakerjaComingSoonToggle ? 'participants__revamp' : 'participants'"
        justify-content="space-between"
      >
        <BlFlexContainerMv v-if="isParticipantsMoreThan30" direction="column" flex="0" class="participant">
          <BlFlexContainerMv class="participant__info" align-items="center">
            <IcoVerify class="participant participant__info-icon" color="#4D2309" />
            <BlTextAv class="participant__value" variation="body-16" weight="medium" style="padding-right: 2px">
              {{ participants }}
            </BlTextAv>
          </BlFlexContainerMv>
          <BlTextAv variation="caption-12" class="text-nowrap">Orang udah ikutan</BlTextAv>
        </BlFlexContainerMv>

        <div v-if="isParticipantsMoreThan30" class="separator participant" />

        <BlFlexContainerMv direction="column" class="age">
          <BlFlexContainerMv class="participant__info" align-items="center">
            <IcoGroup class="age participant__info-icon" color="#4D2309" />
            <BlTextAv variation="body-16" weight="medium" class="age__value text-nowrap" tag="span">
              {{ agePreference }}
            </BlTextAv>
          </BlFlexContainerMv>
          <BlTextAv variation="caption-12" class="text-nowrap">Syarat usia</BlTextAv>
        </BlFlexContainerMv>

        <div class="separator" />

        <BlFlexContainerMv direction="column" class="min_education">
          <BlFlexContainerMv class="participant__info" align-items="center">
            <IcoLearn class="min_education participant__info-icon" color="#4D2309" />
            <BlTextAv variation="body-16" weight="medium" class="min_education__value" style="padding-right: 2px">
              {{ educationLevel }}
            </BlTextAv>
          </BlFlexContainerMv>
          <BlTextAv variation="caption-12" class="text-nowrap">Min. pendidikan</BlTextAv>
        </BlFlexContainerMv>
      </BlFlexContainerMv>
      <BlBreadcrumbAv data-testid="pdp-header-breadcrumb" class="mt-12" :breadcrumb-lists="breadcrumbItems" />
    </div>
  </section>
</template>

<script>
import {BlTextAv, BlCapsuleAv} from '@bukalapak/bazaar-mweb-latest';
import {IcoGroup, IcoStarMinor, IcoVerify, IcoLearn} from '@bukalapak/bazaar-visual-next';
import BlBreadcrumbAv from 'shared/components/BlBreadcrumbAv';
import {COURSE_TYPE} from '../../config/app';
import {mapGetters} from 'vuex';

export default {
  name: 'PrakerjaDetailPageHeader',
  components: {
    BlTextAv,
    IcoGroup,
    IcoVerify,
    IcoStarMinor,
    IcoLearn,
    BlCapsuleAv,
    BlBreadcrumbAv,
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
    courseType: {
      type: String,
      default: '',
    },
    isReviewExists: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('courses', ['getPrakerjaComingSoonToggle']),
    truncatedCourseName() {
      const characters = this.course.name.split('');
      if (characters.length > 20) {
        return characters.slice(0, 20).join('') + '...';
      }
      return this.course.name;
    },
    educationLevel() {
      if (this.course.minimum_education_level === 'tanpa' || !this.course.minimum_education_level) {
        return '-';
      }
      return this.course.minimum_education_level;
    },
    agePreference() {
      const maxAge = this.course.maximum_age ?? 64;
      return this.course.minimum_age + '-' + maxAge;
    },
    participants() {
      return this.course.max_stock - this.course.remaining_stock;
    },
    isParticipantsMoreThan30() {
      return this.participants >= 30;
    },
    courseTypeWording() {
      return COURSE_TYPE[this.courseType];
    },
    breadcrumbItems() {
      return [
        {
          name: 'Beranda',
          url: process.env.BASE_PATH,
        },
        {
          name: this.course.deal.merchant.name,
          url: `${process.env.BASE_PATH}/lembaga/${this.course.deal.merchant.name.replace(/ /g, '-').toLowerCase()}-${this.course.deal.merchant.id}`,
        },
        {
          name: this.truncatedCourseName,
          url: '#',
        },
      ];
    },
  },
  methods: {
    showReviewSheet() {
      this.$emit('showReviewSheet');
    },
  },
};
</script>

<style lang="scss" scoped>
.review {
  background-color: #f8f9fa;
}

.participant__info-icon {
  height: 18px;
  width: 18px;
}

.participants {
  background-color: #fff2e0;
  border-radius: 4px;
  flex: 1 0 0%;
}

.participants__revamp {
  background-color: #ebf2fa;
  border-radius: 4px;
  flex: 1 0 0%;
}

.participant__info {
  gap: 8px;
  text-transform: uppercase;
}

.text-nowrap {
  white-space: nowrap;
}

.separator {
  border-right: 1px solid #e0e0e0;
  height: 12px;
  align-self: center;
  margin: 0 8px;
}
</style>
